/* Squishy advent: reveal, countdown, advent doors, squish demo (+ legacy helpers) */
(function () {
  if (window.__sqCoreLoaded) return;
  window.__sqCoreLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sq-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Breath guide: a circle that grows/shrinks with the plush, with "wdech / wydech" label and a 60 s counter */
  function initBreath(root) {
    (root || document).querySelectorAll('.sq-breath:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var label = wrap.querySelector('.sq-breath__label');
      var count = wrap.querySelector('.sq-breath__count');
      var scope = wrap.closest('.sq-section') || wrap.parentNode;
      var btn = scope.querySelector('.sq-breath__start');
      var cycle = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sq-breath')) || 10;
      var running = false, t0 = 0, raf;
      var soundBtn = scope.querySelector('.sq-breath__sound');
      var audio = null, soundOn = true;
      function getAudio() {
        if (audio || !wrap.dataset.audio) return audio;
        audio = new Audio(wrap.dataset.audio); audio.loop = true; audio.preload = 'auto'; audio.volume = 0.9;
        return audio;
      }
      if (soundBtn) soundBtn.addEventListener('click', function () {
        soundOn = !soundOn;
        soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        var lbl = soundBtn.querySelector('span'); if (lbl) lbl.textContent = soundOn ? (wrap.dataset.soundOn || 'Dźwięk oddechu') : (wrap.dataset.soundOff || 'Bez dźwięku');
        if (running && getAudio()) { if (soundOn) { audio.currentTime = ((performance.now() - t0) / 1000) % cycle; audio.play().catch(function () {}); } else audio.pause(); }
      });
      function tick(ts) {
        if (!running) return;
        var el = (ts - t0) / 1000;
        var phase = (el % cycle) / cycle;
        if (label) label.textContent = phase < 0.4 ? (wrap.dataset.in || 'wdech') : phase < 0.55 ? (wrap.dataset.hold || 'zatrzymaj') : (wrap.dataset.out || 'wydech');
        if (count) count.textContent = Math.floor(el / cycle) + ' / ' + Math.round(60 / cycle);
        if (el >= 60) { stop(); if (label) label.textContent = wrap.dataset.done || 'spokojniej?'; return; }
        raf = requestAnimationFrame(tick);
      }
      function start() {
        running = true; wrap.classList.add('is-running'); t0 = performance.now();
        if (btn) btn.textContent = wrap.dataset.stop || 'Zatrzymaj';
        if (soundOn && getAudio()) { audio.currentTime = 0; audio.play().catch(function () {}); }
        raf = requestAnimationFrame(tick);
      }
      function stop() {
        running = false; wrap.classList.remove('is-running'); cancelAnimationFrame(raf);
        if (btn) btn.textContent = wrap.dataset.start || 'Oddychaj z nim przez minutę';
        if (audio) { audio.pause(); audio.currentTime = 0; }
      }
      if (btn) btn.addEventListener('click', function () { running ? stop() : start(); });
    });
  }

  /* Evening simulator: toggle "bez / z", timeline rows animate */
  function initEvening(root) {
    (root || document).querySelectorAll('.sq-eve:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var inputs = wrap.querySelectorAll('input[name^="sq-eve-mode"]');
      function apply() {
        var mode = wrap.querySelector('input[name^="sq-eve-mode"]:checked');
        wrap.setAttribute('data-mode', mode ? mode.value : 'with');
      }
      inputs.forEach(function (i) { i.addEventListener('change', apply); });
      apply();
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { wrap.classList.add('is-on'); io.disconnect(); } });
        }, { threshold: 0.35 });
        io.observe(wrap);
      } else wrap.classList.add('is-on');
    });
  }

  /* Character switcher: click a chip -> swap video + name */
  function initChars(root) {
    (root || document).querySelectorAll('.sq-chars:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var chips = wrap.querySelectorAll('.sq-chars__chip');
      var stage = wrap.querySelector('.sq-chars__stage');
      var nameEl = wrap.querySelector('.sq-chars__name');
      var descEl = wrap.querySelector('.sq-chars__desc');
      var link = wrap.querySelector('.sq-chars__cta');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          var panels = stage.querySelectorAll('[data-char]');
          panels.forEach(function (p) {
            var on = p.dataset.char === chip.dataset.char;
            p.classList.toggle('is-active', on);
            var v = p.querySelector('video');
            if (v) { if (on) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
          });
          if (nameEl) nameEl.textContent = chip.dataset.name || '';
          if (descEl) descEl.textContent = chip.dataset.desc || '';
          if (link && chip.dataset.url) link.setAttribute('href', chip.dataset.url);
        });
      });
    });
  }


  /* Real countdown to Advent start (no fake urgency): "[days]" before, "[day]" during 1–24 Dec, hidden after */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-sq-countdown]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var start = new Date((el.dataset.date || '') + 'T00:00:00');
      if (isNaN(start)) return;
      var now = new Date(); var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var diff = Math.round((start - today) / 86400000);
      if (diff > 0) { el.innerHTML = (el.dataset.before || '').replace('[days]', '<b>' + diff + '</b>'); el.hidden = false; }
      else if (diff > -24) { el.innerHTML = (el.dataset.during || '').replace('[day]', '<b>' + (1 - diff) + '</b>'); el.hidden = false; }
    });
  }

  /* Advent board: click a door -> it swings open and reveals a random design from the 4x3 sprite */
  function spritePos(i) { var c = i % 6, r = Math.floor(i / 6); return (c * 20) + '% ' + (r * 100 / 3) + '%'; }
  function initAdvent(root) {
    (root || document).querySelectorAll('.sq-advent:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var names = (wrap.dataset.names || '').split('|').filter(Boolean);
      var count = Math.max(1, Math.min(24, parseInt(wrap.dataset.count, 10) || names.length || 24));
      var nudgeAt = parseInt(wrap.dataset.nudgeAt, 10) || 3;
      var scope = wrap.closest('.sq-section') || wrap;
      var doors = wrap.querySelectorAll('.sq-door');
      var pic = scope.querySelector('.sq-adv__pic'), nameEl = scope.querySelector('.sq-adv__name'), sub = scope.querySelector('.sq-adv__sub');
      var opened = scope.querySelector('[data-opened]'), meter = scope.querySelector('.sq-adv__meter i'), nudge = scope.querySelector('[data-nudge]');
      var n = 0, order = [];
      for (var k = 0; k < 24; k++) order.push(k % count);
      for (var q = order.length - 1; q > 0; q--) { var j = Math.floor(Math.random() * (q + 1)); var tmp = order[q]; order[q] = order[j]; order[j] = tmp; }
      var now = new Date();
      if (now.getMonth() === 11 && now.getDate() <= 24) { var t = wrap.querySelector('.sq-door[data-day="' + now.getDate() + '"]'); if (t) t.classList.add('is-today'); }
      doors.forEach(function (d, i) {
        var design = order[i];
        d.querySelector('.sq-door__inside').style.backgroundPosition = spritePos(design);
        d.addEventListener('click', function () {
          if (!d.classList.contains('is-open')) { d.classList.add('is-open'); n++; }
          d.setAttribute('aria-pressed', 'true');
          if (pic) { pic.classList.remove('is-empty'); pic.textContent = ''; pic.style.backgroundPosition = spritePos(design); pic.animate && pic.animate([{ transform: 'scale(.7)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 600, easing: 'cubic-bezier(.16,1,.3,1)' }); }
          if (nameEl) nameEl.textContent = names[design] || '';
          if (sub) sub.textContent = (sub.dataset.found || '').replace('[day]', d.dataset.day);
          if (opened) opened.textContent = n;
          if (meter) meter.style.width = (n / 24 * 100) + '%';
          if (nudge && n >= nudgeAt) nudge.hidden = false;
        });
      });
      var reset = scope.querySelector('[data-reset]');
      if (reset) reset.addEventListener('click', function () {
        doors.forEach(function (d) { d.classList.remove('is-open'); d.removeAttribute('aria-pressed'); });
        n = 0; if (opened) opened.textContent = 0; if (meter) meter.style.width = 0; if (nudge) nudge.hidden = true;
        if (pic) { pic.classList.add('is-empty'); pic.textContent = '?'; pic.style.backgroundPosition = ''; }
        if (nameEl) nameEl.textContent = nameEl.dataset.empty || ''; if (sub) sub.textContent = sub.dataset.empty || '';
      });
    });
  }

  /* Squish demo: press & hold -> squashes fast, release -> slow rise (CSS transition) */
  function initSquish(root) {
    (root || document).querySelectorAll('.sq-squish-demo:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var btn = wrap.querySelector('.sq-sqz__btn'), body = wrap.querySelector('.sq-squishy'), out = wrap.querySelector('[data-sq-count]');
      var n = 0, label = wrap.dataset.label || '[n]';
      function down(e) { if (e && e.cancelable) e.preventDefault(); btn.classList.add('is-pressed'); body.classList.add('is-pressed'); }
      function up() { if (!body.classList.contains('is-pressed')) return; btn.classList.remove('is-pressed'); body.classList.remove('is-pressed'); n++; if (out) out.textContent = label.replace('[n]', n); }
      btn.addEventListener('pointerdown', down);
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { btn.addEventListener(ev, up); });
      btn.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') down(e); });
      btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') up(); });
    });
  }

  function init() { initReveal(document); initBreath(document); initEvening(document); initChars(document);  initCountdown(document); initAdvent(document); initSquish(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initBreath(e.target); initEvening(e.target); initChars(e.target); initCountdown(e.target); initAdvent(e.target); initSquish(e.target); });
})();

/* Dawn: formularz „Dodaj do koszyka” w sekcji SQ | Końcowe CTA otwiera szufladę koszyka zamiast przeładowania */
(function () {
  if (window.__sqCtaAjax) return; window.__sqCtaAjax = true;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('sq-cta__form')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionsToRender || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res.status) { form.submit(); return; } drawer.renderContents(res); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();
